import Cookies from 'js-cookie';
import React, { createContext, useEffect, useReducer, useRef } from 'react';
import posthog from 'configs/posthog';
import db from 'db/db';

export const AdminContext = createContext();

const initialState = {
  adminInfo: Cookies.get('adminInfo')
    ? JSON.parse(Cookies.get('adminInfo'))
    : null,

};

function reducer(state, action) {
  switch (action.type) {
    case 'USER_LOGIN':
      return { ...state, adminInfo: action.payload };

    case 'USER_LOGOUT':
      db.treeCache.clear();
      return {
        ...state,
        adminInfo: null
      };

    default:
      return state;
  }
}

export const AdminProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const previousAdminId = useRef();

  useEffect(() => {
    const adminId = state.adminInfo?.id;

    if (!adminId) {
      if (previousAdminId.current) posthog.reset();
      previousAdminId.current = undefined;
      return;
    }

    if (previousAdminId.current && previousAdminId.current !== adminId) {
      posthog.reset();
    }

    if (previousAdminId.current !== adminId) {
      posthog.identify(adminId, {
        login: state.adminInfo.login,
        name: state.adminInfo.name,
        role: state.adminInfo.role,
      });
      previousAdminId.current = adminId;
    }
  }, [state.adminInfo]);

  const value = { state, dispatch };
  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};
